import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TopToolbar from "../components/TopToolbar.jsx"; // 導入 TopToolbar

const YourComponent = () => {
    const [response, setResponse] = useState(null); // API 响应数据
    const [loading, setLoading] = useState(false); // 加载状态
    const [error, setError] = useState(null); // 错误状态
    const [searchStart, setSearchStart] = useState(''); // 搜索开始时间
    const [searchEnd, setSearchEnd] = useState(''); // 搜索结束时间
    const [lastApiCallTime, setLastApiCallTime] = useState(null); // 上次 API 调用时间
    const [filteredData, setFilteredData] = useState([]); // 过滤后的数据显示
    const [sheetData, setSheetData] = useState({}); // Google Sheet 数据

    // API Gateway 端点
    const apiUrl = 'https://2k0tyfq069.execute-api.ap-east-1.amazonaws.com/current_stage/stream';
    const googleSheetId = '1fQwkxil-foADfQFMWw9WNi_ms1lfcH1xIA5Omcnn5_M'; // Google Sheet ID
    const googleSheetUrl = `https://docs.google.com/spreadsheets/d/${googleSheetId}/gviz/tq?tqx=out:json`;
    const googleSheetUrlForButton = "https://docs.google.com/spreadsheets/d/1fQwkxil-foADfQFMWw9WNi_ms1lfcH1xIA5Omcnn5_M/edit?usp=sharing";

    // 调用 API 的函数
    const callAPI = async () => {
        setLoading(true);
        setError(null);
        setResponse(null);

        try {
            const result = await axios.post(apiUrl, {
                // 传递所需的参数
                key: 'value',
            });

            // 解析 body 字段
            const data = JSON.parse(result.data.body);
            setResponse(data);
            setFilteredData(data.data.sort((a, b) => a.Serial_Number.localeCompare(b.Serial_Number))); // 排序
            setLastApiCallTime(new Date()); // 更新 API 调用时间
        } catch (err) {
            setError(err.message || 'Failed to call API!');
        } finally {
            setLoading(false);
        }
    };

    const fetchGoogleSheetData = async () => {
        try {
            const response = await axios.get(googleSheetUrl);
            const text = response.data;
            const json = JSON.parse(text.substr(47).slice(0, -2)); // 清理返回的数据
            const rows = json.table.rows.map((row) =>
                row.c.map((cell) => (cell ? cell.v : ""))
            );

            // 转换为以 Serial Number 为键的对象
            const sheetDataObj = rows.reduce((acc, row) => {
                const serialNumber = row[0]; // 假设 Serial Number 在第 0 列
                if (serialNumber) {
                    acc[serialNumber] = {
                        RoomNumber: row[2] || "N/A", // 假设房间号在第 2 列
                        RoomType: row[3] || "N/A", // 假设房间类型在第 3 列
                        BedType: row[4] || "N/A", // 假设床类型在第 4 列
                        SleepingMatMAC: row[5] || "N/A", // 假设 Sleeping-mat MAC 在第 5 列
                        DeviceMAC: row[6] || "N/A", // 假设 Device MAC 在第 6 列
                        WingAndView: row[7] || "N/A", // 假设 Wing & View 在第 7 列
                        Version: row[8] || "N/A", // 假设 Version 在第 8 列
                    };
                }
                return acc;
            }, {});
            setSheetData(sheetDataObj);
        } catch (err) {
            console.error("Failed to fetch Google Sheet data:", err.message);
        }
    };

    useEffect(() => {
        callAPI(); // 调用现有的 API
        fetchGoogleSheetData(); // 加载 Google Sheet 数据
    }, []);

    // 定时刷新“上次调用 API 的时间”
    useEffect(() => {
        const interval = setInterval(() => {
            setLastApiCallTime((prev) => prev); // 强制刷新时间
        }, 60000); // 每分钟刷新
        return () => clearInterval(interval);
    }, []);

    // 过滤数据：根据 Search Start 和 Search End
    useEffect(() => {
        if (response) {
            const filtered = response.data.filter((item) => {
                const itemStartTime = new Date(item.start_time).getTime();
                const itemEndTime = new Date(item.end_time).getTime();
                const searchStartTime = searchStart ? new Date(searchStart).getTime() : null;
                const searchEndTime = searchEnd ? new Date(searchEnd).getTime() : null;

                return (
                    (!searchStartTime || itemEndTime >= searchStartTime) &&
                    (!searchEndTime || itemStartTime <= searchEndTime)
                );
            });
            setFilteredData(filtered.sort((a, b) => a.Serial_Number.localeCompare(b.Serial_Number)));
        }
    }, [searchStart, searchEnd, response]);

    // 时间格式化函数：将时间转换为 UTC+8，并格式化为 MM-DD (HH:MM)
    const formatTime = (timeStr) => {
        const date = new Date(timeStr);
        date.setHours(date.getHours()); // 转换为 UTC+8
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${month}-${day} (${hours}:${minutes})`;
    };

    const handleButtonClick = () => {
        window.open(googleSheetUrlForButton, "_blank");
    };

    return (
        <div style={styles.container}>
            <TopToolbar /> {/* 使用 TopToolbar */}
            <h2 style={styles.title}>AromaPodPro Status Lookup Table</h2>

            {/* 工具栏 */}
            <div style={styles.toolbar}>
                <input
                    type="datetime-local"
                    placeholder="Search Start Datetime"
                    value={searchStart}
                    onChange={(e) => setSearchStart(e.target.value)}
                    style={styles.input}
                />
                <input
                    type="datetime-local"
                    placeholder="Search End Datetime"
                    value={searchEnd}
                    onChange={(e) => setSearchEnd(e.target.value)}
                    style={styles.input}
                />
                <button onClick={callAPI} disabled={loading} style={styles.button}>
                    {loading ? 'Loading...' : 'Refresh'}
                </button>
                <button onClick={handleButtonClick} style={styles.button_red}>
                    Edit Room Data
                </button>
            </div>

            {/* 显示上次调用 API 的时间 */}
            {lastApiCallTime && (
                <p style={styles.apiCallInfo}>
                    Last Update: {lastApiCallTime.toLocaleString()}
                </p>
            )}

            {/* 错误提示 */}
            {error && <p style={styles.error}>错误: {error}</p>}

            {/* 响应数据 */}
            {response && (
                <div style={styles.response}>
                    <h3>RESULT</h3>
                    <div style={styles.dataContainer}>
                        {Object.entries(
                            filteredData.reduce((acc, item) => {
                                const key = item.Serial_Number;
                                if (!acc[key]) acc[key] = [];
                                acc[key].push(item);
                                return acc;
                            }, {})
                        ).map(([serialNumber, items]) => {
                            const sheetRow = sheetData[serialNumber] || {};
                            return (

                                <div key={serialNumber} style={styles.itemGroup}>
                                    <h3 style={styles.serialNumberTitle}>
                                        {serialNumber} ({items.length})
                                    </h3>

                                    {/* Google Sheet 数据 */}
                                    <div style={styles.googleSheetContainer}>
                                        <div style={styles.googleSheetRow}>
                                            <strong>Room Number:</strong> {sheetRow.RoomNumber || "No Paired-up Data"}
                                        </div>
                                        <div style={styles.googleSheetRow}>
                                            <strong>Room Type:</strong> {sheetRow.RoomType || "No Paired-up Data"}
                                        </div>
                                        <div style={styles.googleSheetRow}>
                                            <strong>Bed Type:</strong> {sheetRow.BedType || "No Paired-up Data"}
                                        </div>
                                        <div style={styles.googleSheetRow}>
                                            <strong>Sleeping-mat MAC:</strong> {sheetRow.SleepingMatMAC || "No Paired-up Data"}
                                        </div>
                                        <div style={styles.googleSheetRow}>
                                            <strong>Device MAC:</strong> {sheetRow.DeviceMAC || "No Paired-up Data"}
                                        </div>
                                        <div style={styles.googleSheetRow}>
                                            <strong>Wing & View:</strong> {sheetRow.WingAndView || "No Paired-up Data"}
                                        </div>
                                        <div style={styles.googleSheetRow}>
                                            <strong>Version:</strong> {sheetRow.Version || "No Paired-up Data"}
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            ...styles.itemList,
                                            maxHeight: items.length > 5 ? '200px' : 'auto', // 限制高度并启用滚动条
                                            overflowY: items.length > 5 ? 'scroll' : 'visible',
                                        }}
                                    >
                                        {items.map((item, index) => (
                                            <div key={index} style={styles.itemCard}>
                                                <p>
                                                    {formatTime(item.start_time)} - {formatTime(item.end_time)}{' '}
                                                    [{item.scheduled_paramters.element}] [{item.scheduled_paramters.intensity}]
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

// 样式
const styles = {
    container: {
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '20px',
    },
    toolbar: {
        display: 'flex',
        flexWrap: 'wrap', // 自动换行
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '20px',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        flex: '1', // 自适应宽度
        minWidth: '250px', // 确保在移动设备上不太窄
    },
    button: {
        padding: '10px 20px',
        fontSize: '16px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    },
    button_red: {
        padding: '10px 20px',
        fontSize: '16px',
        backgroundColor: '#e63946',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    },
    apiCallInfo: {
        marginBottom: '20px',
        fontSize: '14px',
        color: '#555',
    },
    error: {
        color: 'red',
        marginTop: '10px',
    },
    response: {
        marginTop: '20px',
        padding: '10px',
        backgroundColor: '#f5f5f5',
        borderRadius: '5px',
    },
    dataContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '20px',
        marginTop: '20px',
    },
    itemGroup: {
        marginBottom: '20px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
        borderRadius: '5px',
    },
    serialNumberTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    itemList: {
        padding: '10px',
        backgroundColor: '#fff',
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    itemCard: {
        padding: '5px 0',
        fontSize: '14px',
        borderBottom: '1px solid #eee',
    },
    googleSheetContainer: {
        marginBottom: '10px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
        borderRadius: '5px',
        textAlign: 'left',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    },
    googleSheetRow: {
        marginBottom: '5px',
        fontSize: '14px',
        color: '#333',
        lineHeight: '1.5',
    },

    '@media (max-width: 768px)': {
        input: {
            width: '100%', // 在小屏幕上输入框占满行
            marginBottom: '10px', // 增加上下间距
        },
    },
};

export default YourComponent;